var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLabelOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.77018 11.9577C1.38129 11.9577 1.04796 11.8188 0.770182 11.541C0.492404 11.2632 0.353516 10.9299 0.353516 10.541V1.45768C0.353516 1.06879 0.492404 0.73546 0.770182 0.457682C1.04796 0.179905 1.38129 0.0410156 1.77018 0.0410156H10.4577C10.791 0.0410156 11.0931 0.124349 11.3639 0.291016C11.6348 0.457682 11.8743 0.679904 12.0827 0.957682L15.0618 5.16602C15.2424 5.40213 15.3327 5.67296 15.3327 5.97852C15.3327 6.28407 15.2424 6.56879 15.0618 6.83268L12.0827 11.041C11.8743 11.3188 11.6348 11.541 11.3639 11.7077C11.0931 11.8743 10.791 11.9577 10.4577 11.9577H1.77018ZM13.8743 5.99935L10.6868 1.45768H1.77018V10.541H10.6868L13.8743 5.99935ZM1.77018 5.99935V10.541V1.45768V5.99935Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabelOutline);
export default __webpack_public_path__ + "static/media/labelOutline.cf62bd5d.svg";
export { ForwardRef as ReactComponent };